import {
  CLEAR_FAQ,
  CLEAR_STATE,

  DELETE_FAQ,
  DELETE_FAQ_ERROR,
  DELETE_FAQ_SUCCESS,

  GET_FAQ,
  GET_FAQ_ERROR,
  GET_FAQ_SUCCESS,

  GET_FAQS,
  GET_FAQS_ERROR,
  GET_FAQS_SUCCESS,

  SAVE_FAQ,
  SAVE_FAQ_ERROR,
  SAVE_FAQ_SUCCESS,

} from './constants';

export default {
  [CLEAR_FAQ](state) {
    state.faq = {
      syndicateID: null,
      question: null,
      answer: null,
    };
  },

  [CLEAR_STATE](state) {
    state.error = false;
    state.success = false;
  },

  [DELETE_FAQ](state) {
    state.error = false;
    state.loading = true;
  },
  [DELETE_FAQ_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_FAQ_SUCCESS](state) {
    state.faq = false;
    state.loading = false;
  },

  [GET_FAQ](state) {
    state.faq = false;
    state.error = false;
    state.loading = true;
  },
  [GET_FAQ_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_FAQ_SUCCESS](state, payload) {
    state.faq = payload;
    state.loading = false;
  },

  [GET_FAQS](state) {
    state.faqs = [];
    state.error = false;
    state.loading = true;
  },
  [GET_FAQS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_FAQS_SUCCESS](state, payload) {
    const faqData = payload.data.map(faq => ({ ...faq, collapsed: true }));
    state.faqs = faqData;
    state.loading = false;
  },

  [SAVE_FAQ](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_FAQ_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_FAQ_SUCCESS](state, payload) {
    state.faq = payload;
    state.success = true;
    state.formLoading = false;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.faq[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/FAQs/mutations.js